var EstimateShippingPostcode = (function () {
    var eventHandler = $({});

    var _postcode;
    var _pickupPoint;

    var _hasAddress = null;
    return {
        set: function (postcode, silent) {
            _postcode = postcode;
            !silent && eventHandler.trigger('postcode', postcode);
        },
        get: function () {
            return _postcode || null;
        },
        on: function (func) {
            eventHandler.on('postcode', func);
        },

        getDeliveryDetails: function () {
            if (!_hasAddress) {
                return {
                    Postcode: _postcode || null,
                    PickupPoint: null
                };
            }
            return null;
        },
        hasAddress: function (value) {
            if (value !== undefined) {
                _hasAddress = value;
            }
            return _hasAddress;
        }
    }
})();